import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { MoreInfoTooltipDynamicForms } from '../../../../../elements/Tooltip';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import { get } from 'lodash';
import './style.scss';

const PremiumHeader = (props: FieldProps) => {
  const moreInfo = props.uischema?.options?.moreInfo;
  
  return (
    <div className="premium-header">
      <p>
        <span className="total-price">${get(props?.formData, props?.path)}<span className="sub"> {props.label}</span></span>
      </p>
      {moreInfo && <MoreInfoTooltipDynamicForms moreInfo={moreInfo} />}
    </div>
  );
};

export const PremiumHeaderEntry = {
  tester: rankWith(1, uiTypeIs('PremiumHeader')),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(PremiumHeader)),
};
